"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.licenseActivity = void 0;
const licenseActivity = (topic, license) => ({
    topic,
    objectReference: {
        shopId: license.id,
        zundId: license.externalId,
        name: license.name,
    },
    data: {
        machineShopId: license.massiveMachine?.id,
        machineZundId: license.massiveMachine?.externalId,
    },
});
exports.licenseActivity = licenseActivity;
